import { Rating as MaterialRating } from '@mui/material';
import type { RatingProps } from '@mui/material';

const Rating = ({ ...props }: RatingProps) => {
  return <MaterialRating {...props} />;
};

export default Rating;
